export default "__VITE_ASSET__818a7163__"